import { clsx } from 'clsx'
import { Link } from 'wouter-preact'
import { type ProjectV2 } from 'core'

import { Typography } from 'components'
import { RightArrowIcon } from 'components/UI'

const DAppCard = ({ dApp }: { dApp: ProjectV2 }) => (
	<Link
		class='group mb-4 flex cursor-pointer justify-between rounded-md border border-black-800 bg-gradient-to-r from-black-800 to-black-900 px-3 py-4 transition-all hover:bg-black-850 hover:from-transparent hover:to-transparent'
		href={`/dapp/${dApp.publicId}`}
		style={{
			background: 'linear-gradient(90deg, #323437 -16.84%, #151515 23.32%)'
		}}
	>
		<div class='flex flex-col'>
			<div class='mb-4 flex items-center space-x-2'>
				<div
					class={clsx(
						'flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold text-black-900'
					)}
					style={{ backgroundColor: dApp.color!.default }}
				>
					{dApp.name[0]?.toLocaleUpperCase()}
				</div>
				<Typography
					class='group-hover:underline'
					color='text-black-100'
					text={dApp.name}
					variant='h4'
				/>
			</div>
			<div class='mb-4 mt-0 flex space-x-4 text-sm text-gray-400'>
				<Typography
					class='inline-block'
					color='text-black-200'
					text={dApp.owner.email}
					variant='text4'
				/>
				<Typography
					class='inline-block'
					color='text-black-200'
					text={dApp.publicId}
					variant='text4'
				/>
			</div>
		</div>
		<RightArrowIcon className='m-2 inline-block' />
	</Link>
)

export { DAppCard }
